 export const userSeedData = {
    user: [
    {
        firstName: "Nick",
        lastName: "Langley",
        userName: "Eddy85",
        password: "1"
    }, { 
        firstName: "Deja",
        lastName: "Gorden",
        userName: "TheCaliforniaCoder",
        password: "1"
    }, {
        firstName: "Tom",
        lastName: "Fairclough",
        userName: "Tommy",
        password: "1"
    }, {
        firstName: "Ma-add",
        lastName: "Al-Jabouri",
        userName: "Maad",
        password: "1"
    }, {
        firstName: "Ana",
        lastName: "Solcan",
        userName: "Ana",
        password: "1"
    }, {
        firstName: "Ethan",
        lastName: "Berk",
        userName: "EBerk",
        password: "1"
    }, {
        firstName: "Hal",
        lastName: "Evans",
        userName: "Hally",
        password: "1"
    }, {
        firstName: "Justin",
        lastName: "Tate",
        userName: "JT",
        password: "1"
    }, {
        firstName: "Nora",
        lastName: "Zics",
        userName: "Noni",
        password: "1"
    }, {
        firstName: "Selina",
        lastName: "Lavery",
        userName: "Selina",
        password: "1"
    }, {
        firstName: "Usman",
        lastName: "Bashir",
        userName: "Usman",
        password: "1"
    }, {
        firstName: "Joan",
        lastName: "Kalanzi",
        userName: "Joan",
        password: "1"
    },]
    
    }